<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { closeThisModal, isMobile, ModalDialog, modalStack, pushModal } from "@infinitro/global";
import { Modal } from "@infinitro/modal";
import { Text } from "@infinitro/text";
import { onMount } from "svelte";
import { derived } from "svelte/store";
const thisModal = ModalDialog.FeatureUnavailable;
const closeModal = () => closeThisModal(thisModal);
const modalIndex = derived(modalStack, ($modalStack) => $modalStack.findIndex((e) => e.modal === thisModal));
const zOverlay = derived(modalIndex, ($modalIndex) => $modalIndex >= 0 ? 9999 + $modalIndex * 2 : 9999);
const illustrationUrl = cfgToThemeCdnPath(`/icons/warning-icon.png`);
onMount(() => {
	pushModal(ModalDialog.FeatureUnavailable);
});
</script>

<Modal
	title={null}
	{closeModal}
	width="100%"
	height="50vh"
	maxWidth="40rem"
	maxHeight="50vh"
	maxHeightContent="calc(85vh - 95px)"
	padding=""
	closeByBackdrop={true}
	showCloseButton={true}
	alwaysCentered={false}
	notFullScreenMobile={false}
	zIndexOverlay={$zOverlay}
	zIndexUnderlay={$zOverlay - 1}
>
	<div class="content">
		<img
			src={illustrationUrl}
			alt={$t(Verbiage.warning_icon_alt, 'alts')}
			class={$isMobile ? 'icon-mobile' : 'icon'}
		/>

		<Text type="title" titleSize="h4" textColor="white" bodySize="small" textAlign="center">
			{$t(Verbiage.feature_unavailable_title)}
		</Text>

		<Text type="body" titleSize="h5" textColor="white" bodySize="small" textAlign="center">
			{$t(Verbiage.feature_unavailable_description)}
		</Text>

		<Text type="body" titleSize="h5" textColor="gray" bodySize="small" textAlign="center">
			{$t(Verbiage.feature_unavailable_thanks)}
		</Text>
	</div>
</Modal>

<style>
	.content {
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
		padding: 1rem;
		text-align: center;
}

	.icon {
		width: auto;
		height: 200px;
	}

	.icon-mobile {
		width: auto;
		height: 180px;
	}
</style>
